// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27D4S","comment":"styles_comment__1c-sV"};